import * as Attachment from '../Attachment/Attachment';
import { z } from 'zod';
export const artistAttachmentSchema = z.object({
    attachment: Attachment.attachmentSchema,
});
export const fromGql = (item) => ({
    attachment: Attachment.fromGql(item.attachment),
});
export const fromGqlCollection = (items) => items.map(fromGql);
//# sourceMappingURL=ArtistAttachment.js.map